angular.module('eStories.collapsed-feature-carousel.compnt', [
    'eStories.common.directives',
    'eStories.carousel.service',
    'eStories.catalog.model',
    'eStories.compnt.starRating',
    'eStories.compnt.grid',
])

    .component('collapsedFeatureCarousel', {
        transclude: true,
        bindings: {
            type: '@',
            data: '<'
        },
        controller: 'CarouselCtrl',
        controllerAs: 'carouselCtrl',
        templateUrl: '/components/templates/carousels/collapsed-feature-carousel/collapsedFeatureCarousel.tmpl.html'
    })

    .controller('CarouselCtrl', [
        'CarouselService',
        'CatalogModel',
        'AccountModel',
        'PromoModel',
        'ModalsModel',
        'BillingModel',
        'CtaModel',
        '$timeout',
        '$interval',
        '$rootScope',
        '$scope',
        '$state',
        'SeoModel',
        function (CarouselService,
                  CatalogModel,
                  AccountModel,
                  PromoModel,
                  ModalsModel,
                  BillingModel,
                  CtaModel,
                  $timeout,
                  $interval,
                  $rootScope,
                  $scope,
                  $state,
                  SeoModel) {

            this.account = AccountModel;
            this.promo = PromoModel;
            this.billingModel = BillingModel;
            this.cta = CtaModel;
            this.currentState = $state.current.name;
            this.seoModel = SeoModel;

            this.carouselSlides = [];
            this.carouselSlides.length = 12;

            this.dateNow = Date.now();

            this.getPromoHeadlineStyle = () => {
                return JSON.parse(this.promo.promoPackage.featureHeadlineStyle);
            };

            this.audiobookAbridged = abridged => {
                return abridged ? 'Abridged' : 'Unabridged';
            };

            this.getAudiobookRuntime = function (runtime) {
                if (!runtime) return;
                return runtime.toString().toHHMMSS();
            };

            this.getFullDate = date => getFullDate(date);

            this.shouldShowTerms = slide =>
                slide.name !== 'PROMO_BANNER_BASIC_MONTHLY' && slide.name !== "PROMO_BANNER_GROUPON";

            this.currentIndex = 0;

            let preloadedCarouselImages = {};

            this.preloadNextSlide = index => {
                if (index >= this.carouselSlides.length) return;
                let img = new Image;
                if (this.type === 'rotating') {
                    img.src = this.carouselSlides[index].audiobook.coverUrl + '&width=500';
                } else {
                    img.src = this.carouselSlides[index].backgroundUrl + '&width=2560';
                }
                preloadedCarouselImages[index] = true;
            };

            this.setCurrentSlide = index => {
                if (!this.carouselSlides) {
                    return;
                }
                let indexObj = CarouselService.setIndexes(index, this.carouselSlides.length);

                this.currentIndex = indexObj.currentIndex;
                this.nextIndex = indexObj.nextIndex;
                this.previousIndex = indexObj.previousIndex;

                this.currentSlide = this.carouselSlides[this.currentIndex];
                this.previousSlide = this.carouselSlides[this.previousIndex];
                this.nextSlide = this.carouselSlides[this.nextIndex];

                if (Object.keys(preloadedCarouselImages).length === 0
                    && JSON.stringify(preloadedCarouselImages) === JSON.stringify({})) {
                    for (let i = 1; i < this.carouselSlides.length; i++) {
                        if (preloadedCarouselImages[i] == null) {
                            this.preloadNextSlide(i);
                        }
                    }
                }
            };

            this.getPurchaseDate = audiobook => {
                if (audiobook.purchaseDate != null) {
                    return audiobook.purchaseDate;
                }
            };

            this.getCarouselSlides = () => {
                let slides = this.carouselSlides;
                if (slides) {
                    let newData = [];
                    // show only one static slide (either trial or promo)
                    let showingStaticSlide = false;
                    for (let i = 0; i < slides.length; i++) {
                        let slide = slides[i];

                        if (slide.sectionType === 'FEATURE_PROMO') {
                            // Promo slide
                            if (PromoModel.hasPlanPromo() &&
                                slide.promoName === PromoModel.promoPackage.name && !showingStaticSlide) {

                                newData.push(slide);
                                showingStaticSlide = true;
                            }
                        } else if (slide.showOnlyForNonMembers) {
                            // trial slide
                            if (!AccountModel.isMember() && !showingStaticSlide) {
                                newData.push(slide);
                                showingStaticSlide = true;
                            }
                        } else {
                            // non-trial slide (content slides)
                            newData.push(slide);
                        }
                    }
                    this.carouselSlides = newData;
                }
                return this.carouselSlides;
            };

            this.getSlideBackgroundStyle = url => {
                if (this.carouselSlides !== null) {
                    return getCoverStyleBackground(url + '&width=2560');
                }
            };

            const handleOnChange = data => {
                if (this.type === 'rotating') {
                    if (!data) {
                        this.carouselSlides = new Array(20);
                        safeApply($scope);
                        return;
                    }
                    this.carouselSlides = data;
                    this.setCurrentSlide(this.currentIndex);
                }

                this.data = this.carouselSlides = data;
            };

            handleOnChange(this.data);

            //noinspection JSUnusedGlobalSymbols
            this.$onChanges = changes => {
                handleOnChange(changes.data.currentValue)
            };

            /*Start carousel intervals*/
            if ((this.type === 'feature' || this.type === 'rotating'
                || this.type === 'collapsed') &&
                this.currentState !== 'eStories.navbars.newUser' &&
                this.currentState !== 'eStories.navbars.vipSignUp') {
                $interval(() => {
                    this.setCurrentSlide(this.currentIndex + 1);
                }, 10000);
            }

            this.playSample = audiobook => {
                this.currentlyPlayingSample = true;
                $rootScope.$broadcast('playSample', audiobook);
            };

            this.pauseSample = audiobook => {
                this.currentlyPlayingSample = false;
                $rootScope.$broadcast('pauseSample', audiobook, true);
            };

            this.addToWishList = async audiobook => {
                const response = await CatalogModel.addToWishList(audiobook);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    this.currentSlide.audiobook.wishListItemId = response.wishListItemId;
                }
            };

            this.deleteFromWishList = async (wishListItemId) => {
                const response = await CatalogModel.deleteFromWishList(wishListItemId);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    this.currentSlide.audiobook.wishListItemId = null;
                }
            };

            this.needsAudiobookObjInput = () => CarouselService.needsAudiobookObjInput();

            this.getUrlSectionId = () => {
                if (!this.sectionId) return;
                return this.sectionId.toLowerCase();
            };

            this.getUrlSectionName = () => {
                if (!this.sectionName) return;
                return this.sectionName.toLowerCase();
            };

            this.showNavSignUpModal = () => {
                AccountModel.signUpOrConfirmTrial();
            };

            this.openModal = () => {
                ModalsModel.open('/registration/signInModal.tmpl.html', 'RegistrationCtrl', 'regCtrl');
            };
        }
    ]);